import "./BoothMark.css";

/** The Booth wordmark, set in carol-gothic. Used anywhere the brand signs its name. */
function BoothMark({ as: Tag = "span", className = "", ...rest }) {
  return (
    <Tag className={`booth-wordmark ${className}`.trim()} {...rest}>
      The Booth
    </Tag>
  );
}

export default BoothMark;
